module.exports = __webpack_public_path__ + "assets/img/login-game-master.d21ac5ed.svg";